export const getEnvBaseUrl = (envUrl: string | undefined, proxyUrl: string) => {
  let url = envUrl || proxyUrl;
  if (typeof window !== 'undefined') {
    const isElectron = window.navigator.userAgent.toLowerCase().includes('electron');
    const isFileProtocol = window.location.protocol === 'file:';
    if (!isElectron && !isFileProtocol) {
      // 在普通的 Web 环境中，如果打包时配置了绝对路径，强制使用代理路径，以避免跨域问题
      if (url.startsWith('http')) {
        return proxyUrl;
      }
    }
  }
  return url;
};
